/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FaLaptop } from '@react-icons/all-files/fa/FaLaptop';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import { FaRegPlayCircle } from '@react-icons/all-files/fa/FaRegPlayCircle';
import { FaRegMoneyBillAlt } from '@react-icons/all-files/fa/FaRegMoneyBillAlt';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';
import { FaExclamationCircle } from '@react-icons/all-files/fa/FaExclamationCircle';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import Rating from 'gatsby-core-theme/src/components/molecules/star-rating';
import { translate, imagePrettyUrl, prettyTracker } from 'gatsby-core-theme/src/helpers/getters';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import TnCModal from 'gatsby-core-theme/src/hooks/modal';
import Image from 'gatsby-core-theme/src/hooks/gatsby-img';
import { Context } from '~context/TranslationsProvider';
import { getMarketCountries } from '../../../helpers/getters';
import RegistrationSteps from '../../molecules/registration-steps';
import styles from './sponsored-provider.module.scss';

const SponsoredProvider = ({ pageContext, isStorybook = false }) => {
  const { translations } = useContext(Context) || {};
  const { page } = pageContext;
  const event = page?.relation?.event;
  const sport = page?.relation?.sport;
  // check if there is a main provider or not
  const mainProviders = event?.providers.filter((item) => item.main === 1);
  // if there is a main provider we show only the main, if not we show all of them
  const eventProviders =
    mainProviders && mainProviders.length > 0 ? mainProviders : event?.providers;

  const isMainProvider = (provider) => provider?.main === 1;

  const isMarketProvider = getMarketCountries(page?.market).includes(event?.tournament?.country);

  return (
    <div className={`${styles.sponsor} ${styles[sport?.name]}`}>
      <div className={styles.bg}>
        <Image filename={`ground-image-${sport?.name || 'soccer'}`} alt={`${sport}`} />
      </div>
      <div className={styles.provider}>
        <div className={`${styles.sponsorTitle} ${styles[sport?.name]}`}>
          <FaLaptop />
          <span>{translate(translations, 'sponsored_content', 'Sponsored Content')}</span>
        </div>
        {eventProviders &&
          eventProviders.map((provider) => (
            <div className={styles.providerBox} key={provider.id}>
              <div className={styles.providerTitle}>
                <div className={styles.providerTitleLeft}>
                  {provider.square_logo && (
                    <LazyImage
                      src={imagePrettyUrl(provider?.square_logo)}
                      alt={provider.name}
                      width={34}
                      height={34}
                    />
                  )}
                  <h3>{provider.name}</h3>
                  <Rating numOfStars={5} rating={provider.rating} path={page.path} />
                </div>
                <div className={styles.providerTitleRight}>
                  <div>
                    <FaCheck />
                    <span>{`${translate(translations, 'quality', 'Quality')} :`}</span>
                    <span>{`${translate(translations, provider?.video_quality, '')}`}</span>
                  </div>
                  <div>
                    <FaRegPlayCircle />
                    <span>{`${translate(translations, 'player', 'Player')} :`}</span>
                    <span>{`${translate(translations, provider?.video_size, '')}`}</span>
                  </div>
                  <div>
                    <FaRegMoneyBillAlt />
                    <span>{`${translate(translations, 'price', 'Price')} : `}</span>
                    <span>{provider?.price ? provider?.price : '-'}</span>
                  </div>
                </div>
              </div>
              <div className={styles.providerBody}>
                <div className={styles.providerBodyLeft}>
                  <h3>
                    {`${translate(
                      translations,
                      'how_to_watch_live_stream',
                      'How to watch live stream'
                    )} 
                  ${sport?.path} 
                  ${translate(translations, 'with_2', 'with')} 
                  ${provider.name}`}
                  </h3>
                  <div className={styles.steps}>
                    <RegistrationSteps
                      sport={sport.name}
                      steps={provider}
                      link={prettyTracker(provider, 'main', true)}
                      provider={provider}
                      pageType={page.type}
                      isStorybook={isStorybook}
                      gtmClass="sponsored-provider-registration-steps-gtm"
                    />
                  </div>
                </div>
                <div>
                  <LazyImage
                    className={styles.seperator}
                    src={isStorybook ? './sep-arw.png' : '../../../images/sep-arw.png'}
                    alt="seperator"
                    width={29}
                    height={267}
                  />
                </div>
                <div className={styles.providerBodyRight}>
                  <span>
                    {translate(
                      translations,
                      'disable_adblock_temporarily',
                      'The link opens in a new tab - Please deactivate your Adblock temporarily.'
                    )}
                  </span>
                  <Button
                    to={prettyTracker(provider, 'main', true)}
                    targetBlank={false}
                    isInternalLink={false}
                    btnText={
                      <>
                        <FaChevronCircleRight />
                        {`${translate(translations, 'see', 'See')} ${sport?.path} live`}
                        <span>
                          {`- ${translate(translations, 'with_1', 'with')} ${provider.name}`}
                        </span>
                      </>
                    }
                    gtmClass="sponsored-provider-gtm btn-cta"
                  />
                  {isMainProvider(provider) && isMarketProvider && (
                    <span className={styles.ipProvider}>
                      <FaExclamationCircle />
                      {translate(
                        translations,
                        'not_possible_with_ip_address',
                        'Not possible with this IP address'
                      )}
                    </span>
                  )}
                  <div className={styles.terms}>
                    {isMainProvider(provider) && provider?.sports_data[sport.name]?.disclaimer && (
                      <TnCModal content={provider?.sports_data[sport.name]?.disclaimer}>
                        <span className={styles.modalTrigger}>
                          {translate(translations, 'terms_and_conditions', 'Terms and conditions')}
                        </span>
                      </TnCModal>
                    )}
                  </div>
                  <span>
                    {translate(
                      translations,
                      'qualify_for_bet',
                      'To qualify, you simply need to have a funded account or have placed a bet within the last 24 hours.'
                    )}
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default SponsoredProvider;

SponsoredProvider.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      type: PropTypes.string,
      market: PropTypes.string,
      path: PropTypes.string,
      relation: PropTypes.shape({
        event: PropTypes.shape({
          providers: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        sport: PropTypes.shape({}),
      }),
    }),
  }).isRequired,
  isStorybook: PropTypes.bool,
};
